// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CircleOutlinedSvg from "@fishx/icons-svg/es/asn/CircleOutlined";
import FishxIcon from '../components/FishxIcon';

var CircleOutlined = function CircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CircleOutlinedSvg
  }));
};

CircleOutlined.displayName = 'CircleOutlined';
export default React.forwardRef(CircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CircleOutlined.js
// module id = 2217
// module chunks = 0